<template>
  <page style="height: 100vh; overflow: hidden">
    <div slot="head" class="page-head-default">
      <img src="../assets/imgs/menu.png" alt="" @click="isMenuView = true" />
      {{ title }}
    </div>
    <div>
      <div class="home-warp" v-if="isScan && cabinet && !isBtns">
        <div class="banner" :style="banner"></div>
        <div class="home-warp-main">
          <div class="home-warp-block"></div>
          <div class="home-warp-cont">
            <div class="home-warp-title">
              <img src="../assets/imgs/map.png" alt="" />
              <span>{{ cabinet.shopname }}</span>
            </div>
            <div class="home-warp-jifei">
              <span>{{ cabinet.currencyName }}{{ cabinet.jifei }}</span
              >/{{ cabinet.jifeiDanwei }}{{ i18n.minute }}
            </div>
            <div class="home-warp-row">{{ shopDesc }}</div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_phone.png" alt="" />
              {{ i18n.feature_1 }}
            </div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_star.png" alt="" />
              {{ i18n.feature_2 }}
            </div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_tag.png" alt="" />
              {{ i18n.feature_3 }}
            </div>
          </div>
          <!-- <div class="home-warp-btn" v-if="cabinet.chongzhi === 'Y'">
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="">
              <span>{{shopTips1}}</span>
            </div>
            <button v-if="browser === 'wechat'" class="btn" @click="onWechatPay">{{i18n.submit}} {{cabinet.currencyName}}{{amount}} {{cabinet.currency}}</button>
            <button v-else-if="browser === 'alipay'" class="btn" @click="onAlipay">{{i18n.submit}} {{cabinet.currencyName}}{{amount}} {{cabinet.currency}}</button>
            <div v-else class="btn" @click="onSubmit">{{i18n.submit}} {{cabinet.currencyName}}{{amount}} {{cabinet.currency}}</div>
          </div> -->
          <div class="home-warp-btn">
            <!-- <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="">
              <span>{{shopTips3}}</span>
            </div> -->
            <div class="btn" @click="onBorrow">{{ i18n.borrow }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <img class="home-bg" src="../assets/imgs/bg.png" alt="" />
        <div class="home-foot">
          <div class="home-btns">
            <!-- <a
              v-if="system === 'ios'"
              style="background: #000"
              :href="VUE_APP_APP_STORE"
            >
              <img src="../assets/imgs/apple.png" alt="" />
              <span>App Store</span>
            </a>
            <a v-else style="background: #000" :href="env.VUE_APP_GOOGLE_PLAY">
              <img src="../assets/imgs/google.png" alt="" />
              <span>Google Play</span>
            </a> -->
            <!-- v-if="code" -->
            <a
              @click="onCode"
              style="
                background: #f08421;
                color: #fff;
                border: 1px solid #f08421;
              "
            >
              <span>{{ i18n.goborrow }}</span>
            </a>
          </div>
          <span class="nearby" @click="goNearby">{{ i18n.nearby }} ></span>
        </div>
      </div>
      <popup-warp v-model="isMenuView" dialogTransition="slide-left">
        <menu-side></menu-side>
      </popup-warp>
    </div>
  </page>
</template>

<script>
import { PopupWarp } from "../components/popup"
import { MenuSide } from "../components/menu"
import { mapState } from "vuex"
import {
  QR_CODE,
  ZH_CODE,
  ORDER_PAYU_CONFIRM,
  ORDER_GOPAY,
  ORDER_GOPAY_CONFIRM
} from "../apis/cabinet"
import { WECHAT_MP_PRE_PAY, ALIPAY_PRE_PAY } from "../apis/payment"
import { USER_INFO } from "../apis/user"
import wxMixin from "../mixins/wx"
import alipayMixin from "../mixins/alipay"
export default {
  mixins: [wxMixin, alipayMixin],
  components: {
    PopupWarp,
    MenuSide
  },
  computed: {
    ...mapState(["qrcode", "zhcode", "cabinet", "browser", "user", "system"]),
    lang() {
      return this.$store.state.lang.split("-")[0] || "en"
    },
    i18n() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    i18nConfirm() {
      return this.$t("confirm")
    },
    title() {
      return process.env.VUE_APP_NAME
    },
    code() {
      return this.qrcode || this.zhcode
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}`
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ""
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : ""
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format(this.cabinet)
    },
    shopTips1() {
      return `${this.i18n.tips_1}`.format(this.cabinet)
    },
    shopTips2() {
      return `${this.i18n.tips_2}`.format(this.cabinet)
    },
    shopTips3() {
      return `${this.i18n.tips_3}`.format(this.cabinet)
    },
    amount() {
      if (this.cabinet) {
        return (this.cabinet.yajin - this.cabinet.myyue).toFixed(2)
      } else {
        return 0
      }
    },
    env() {
      return process.env
    }
  },
  data() {
    return {
      isMenuView: false,
      isScan: false,
      isBtns: false
    }
  },
  methods: {
    onScan() {
      if (!this.scanUrl) return
      this.$loading(true)
      this.$post(
        this.scanUrl,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          })
          this.isScan = true
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onSubmit() {
      this.$router.push({
        path: "/confirm",
        query: { price: this.amount, payType: "YJ" }
      })
    },
    onBorrow() {
      // GoPay 支付
      this.$loading(true)
      this.$get(
        `${ORDER_GOPAY}?qrCode=${this.cabinet.qrcode}&paymentId=17&continueUrl=https://energy-point-sharing.eu&language=${this.lang}`,
        {},
        (resp) => {
          // console.log(resp)
          if (resp.code === 0) {
            const data = resp.data
            if (data.order_number) {
              localStorage.setItem("trade_no", data.order_number) // 保存本次租借的订单号，重定向回首页时如果有订单号则进行订单支付确认，确认成功去result轮询
              location.href = data.gw_url
            } else {
              this.$toast(this.i18nMsg.title_fail)
            }
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.confirm,
            content: error,
            confirmText: this.i18nConfirm.msg_fail_confirm,
            showCancel: false
          })
            .then(() => {})
            .catch(() => {})
        }
      )
      // PayU 支付
      /* this.$loading(true)
      this.$get(`${ORDER_PAYU}?qrCode=${this.cabinet.qrcode}&paymentId=17&continueUrl=https://energy-point-sharing.eu&language=${this.lang}`,
        {},
        resp => {
          // console.log(resp)
          if (resp.code === 0) {
            const creatOrderResult = resp.data.creatOrderResult
            location.href = creatOrderResult.redirectUri
            localStorage.setItem('trade_no', creatOrderResult.extOrderId) // 保存本次租借的订单号，重定向回首页时如果有订单号则进行订单支付确认，确认成功去result轮询
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.confirm,
            content: error,
            confirmText: this.i18nConfirm.msg_fail_confirm,
            showCancel: false
          }).then(() => {}).catch(() => {})
        }
      ) */
      /* this.$post(
        `${ORDER_TEMP}/${this.cabinet.qrcode}/paypal`,
        {},
        resp => {
          this.$loading(false)
          console.log(resp)
          if (resp.orderid) {
            this.$router.push(`/result?tradeNo=${resp.orderid}`)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        error => {
          this.$loading(false)
          this.$toast(error)
        }
      ) */
    },
    onWechatPay(event) {
      this.$loading(true)
      console.log("event", event)
      const vm = this
      this.$post(
        `${WECHAT_MP_PRE_PAY}/${this.cabinet.qrcode}`,
        {
          amount: this.amount,
          formId: event.detail.formId || ""
        },
        (resp) => {
          this.$loading(false)
          console.log("wechat pre pay", resp)
          const data = resp.data
          wx.chooseWXPay({
            timestamp: data.timeStamp,
            nonceStr: data.nonceStr,
            package: data.package,
            signType: data.signType,
            paySign: data.paySign,
            success: function (res) {
              vm.$router.push(`/result?tradeNo=${data.out_trade_no}`)
            },
            fail: function (res) {
              console.log("wxpay fail", res)
              vm.$toast(res.errMsg)
            }
          })
        },
        (error) => {
          console.log("wechat pre pay error", error)
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onAlipay(event) {
      this.$loading(true)
      console.log("event", event)
      const vm = this
      this.$post(
        `${ALIPAY_PRE_PAY}/${this.cabinet.qrcode}`,
        {
          amount: this.amount
        },
        (resp) => {
          this.$loading(false)
          console.log("alipay", resp)
          const data = resp.data
          ap.tradePay(
            {
              // tradeNO: data.timeStamp,
              // partnerID: data.nonceStr,
              // bizType: data.package,
              // bizSubType: data.signType,
              // bizContext: data.paySign,
              orderStr: data
            },
            (res) => {
              if (res.resultCode === 9000) {
                vm.$router.push(`/result?tradeNo=${data.out_trade_no}`)
              } else {
                console.log("alipay fail", res)
                vm.$toast(res.resultCode)
              }
            }
          )
        },
        (error) => {
          console.log("alipay error", error)
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        (resp) => {
          if (resp.user) {
            this.$store.commit("user", resp.user)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              confirmText: this.i18nMsg.retry,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        (error) => {
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    onAppStore() {
      window.location.href = process.env.VUE_APP_APP_STORE
    },
    onGooglePlay() {
      window.location.href = process.env.VUE_APP_GOOGLE_PLAY
    },
    onCode() {
      if (this.user) {
        if (!this.code) {
          this.$toast(this.i18n.no_device)
          return
        }
        this.isBtns = false
        this.loadUser()
        this.onScan()
      } else {
        this.$router.push("/login")
      }
    },
    goNearby() {
      this.$router.push("./google_map")
    },
    confirmPayU(tradeNo) {
      this.$confirm({
        title: this.i18nMsg.confirm,
        content: this.i18nMsg.success_payment,
        confirmText: this.i18nConfirm.msg_fail_confirm,
        cancelText: this.i18nConfirm.msg_fail_cancel
      })
        .then(() => {
          this.$post(
            `${ORDER_PAYU_CONFIRM}?outTradeNo=${tradeNo}`,
            {},
            (resp) => {
              if (resp.code === 0) {
                this.$router.push(`/result?tradeNo=${tradeNo}`)
                localStorage.removeItem("trade_no")
              }
              // console.log(resp)
            },
            (error) => {
              console.log(error)
              this.confirmPayU(tradeNo)
            }
          )
        })
        .catch(() => {
          localStorage.removeItem("trade_no")
        })
    },
    confirmGoPay(tradeNo) {
      this.$confirm({
        title: this.i18nMsg.confirm,
        content: this.i18nMsg.success_payment,
        confirmText: this.i18nConfirm.msg_fail_confirm,
        cancelText: this.i18nConfirm.msg_fail_cancel
      })
        .then(() => {
          this.$post(
            `${ORDER_GOPAY_CONFIRM}?outTradeNo=${tradeNo}&orderType=preAuth`,
            {},
            (resp) => {
              if (resp.code === 0) {
                this.$router.push(`/result?tradeNo=${tradeNo}`)
                localStorage.removeItem("trade_no")
              }
              // console.log(resp)
            },
            (error) => {
              console.log(error)
              this.confirmGoPay(tradeNo)
            }
          )
        })
        .catch(() => {
          localStorage.removeItem("trade_no")
        })
    }
  },
  created() {
    if (this.browser === "wechat") {
      this.loadWXScript(["chooseWXPay"])
    } else if (this.browser === "alipay") {
      this.loadAlipayScript()
    } else {
      this.isBtns = true
      // scheme协议
      /* this.$nextTick(() => {
        console.log(process.env.VUE_APP_SCHEME)
        window.location.href = process.env.VUE_APP_SCHEME
      }) */
    }
    if (!this.isBtns && this.code) {
      this.loadUser()
      this.onScan()
    }
    // 如果不是扫码进入，获取租借的订单号，如果有订单号，确认订单是否支付
    const tradeNo = localStorage.getItem("trade_no")
    if (tradeNo) {
      this.confirmGoPay(tradeNo)
    }
  }
}
</script>

<style lang="less">
.home-warp {
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #fff;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }
  &-main {
    width: 100%;
    height: calc(100vh - 454px);
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  }
  &-block {
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }
  &-cont {
    padding: 0 48px;
  }
  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  &-jifei {
    padding: 60px 0 20px;
    font-size: 42px;
    font-weight: 600;
    span {
      font-size: 68px;
    }
  }
  &-row {
    display: flex;
    font-size: 30px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    color: #999999;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }
  &-btn {
    position: fixed;
    left: 48px;
    right: 48px;
    bottom: 48px;
    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 30px;
    color: #666666;
    padding: 20px 0;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.home-bg {
  width: 100%;
  height: 100vh;
}
.home-btns {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 32px;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  z-index: -1;
  a {
    text-decoration: none;
    width: 30%;
    flex: 1;
    margin: 20px;
    background: #000000;
    color: #ffffff;
    padding: 24px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.go-code {
  text-align: center;
  color: #67c23a;
  text-decoration: underline;
  padding: 10px 0 30px;
}
.home-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  .nearby {
    position: absolute;
    bottom: 170px;
    right: 20px;
    color: #fff;
    text-decoration: underline;
    text-align: center;
  }
}
</style>
